import { render, staticRenderFns } from "./VipPage.vue?vue&type=template&id=62f0158e&scoped=true"
import script from "./VipPage.vue?vue&type=script&lang=js"
export * from "./VipPage.vue?vue&type=script&lang=js"
import style0 from "./VipPage.vue?vue&type=style&index=0&id=62f0158e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f0158e",
  null
  
)

export default component.exports